export enum PdfCellType {
    TEXT,
    NUMBER,
    DATE,
    HEADER
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-cell-type.enum.ts